<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiBriefcaseSearchOutline } from "@mdi/js";
export default {
  name: "MdiBriefcaseSearchOutline",
  data() {
    return {
      svgPath: mdiBriefcaseSearchOutline,
    };
  },
};
</script>
